<template>
  <div class="form-label-group">
    <slot />
    <label v-if="label">
      {{ label }}
    </label>
  </div>
</template>

<script>
export default {
  props: ['label'],
};
</script>

<style>
:root {
  --input-padding-x: 1rem;
  --input-padding-y: 0.75rem;
}

.form-label-group {
  position: relative;
}

.form-label-group > input,
.form-label-group > span > input:placeholder-shown,
.form-label-group > select,
.form-label-group > label {
  padding: var(--input-padding-y) var(--input-padding-x);
}

.form-label-group > label {
  font-size: 1rem;
  padding: 0.75rem 1rem;
  padding-right: 2rem;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  width: 100%;
  margin-bottom: 0; /* Override default `<label>` margin */
  line-height: 1.5;
  color: #495057;
  border: 1px solid transparent;
  border-radius: 0.25rem;
  transition: all 0.1s ease-in-out;
  pointer-events: none;
}

.form-label-group input::placeholder {
  color: transparent;
}

.form-label-group input:not(:placeholder-shown) {
  padding-top: calc(var(--input-padding-y) + var(--input-padding-y) * (2 / 3));
  padding-bottom: calc(var(--input-padding-y) / 3);
}

.form-label-group input:not(:placeholder-shown) ~ label {
  padding-top: calc(var(--input-padding-y) / 3);
  padding-bottom: calc(var(--input-padding-y) / 3);
  font-size: 12px;
  color: #777;
}
</style>



// WEBPACK FOOTER //
// src/components/organisation/FormLabelGroup.vue